var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"pl-1 text-decoration-none info--text",attrs:{"href":"https://www.feriavalencia.com/","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('login.forgotpassword')))])
}
var staticRenderFns = []

export { render, staticRenderFns }